import { HoneyloveWindow } from './models/HoneyloveWindow';

interface MetaEnv {
  [key: string]: string;
}

declare const window: HoneyloveWindow;

const env: MetaEnv = typeof import.meta !== 'undefined' ? ((import.meta as any).env as unknown as MetaEnv) : ({} as MetaEnv);
const findEnvVar = (keys: string[], ssrKey: string): string | number | string[] | undefined => {
  const windowEnv: { [key: string]: any } = typeof window !== 'undefined' ? window.Honeylove?.environment ?? {} : {};
  const windowEnvValue = keys.reduce((acc, key) => (acc[key] ? acc[key] : acc), windowEnv) as unknown as string | number | string[] | undefined;
  const isPrimitive = typeof windowEnvValue === 'string' || typeof windowEnvValue === 'number' || typeof windowEnvValue === 'boolean';
  return windowEnvValue && (isPrimitive || Object.keys(windowEnvValue).length > 0) ? windowEnvValue : env[ssrKey];
};
export const findEnvVarString = (keys: string[], ssrKey: string): string => (findEnvVar(keys, ssrKey) ?? '') as string;

export const environmentContext = {
  dataApiDomain: findEnvVarString(['dataApiDomain'], 'PUBLIC_DATA_API_DOMAIN'),
};

Object.freeze(environmentContext);
